import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExplosionIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12.25 4L12.75 3.5M13 10.75L13.5 11M7.5 13.75V14.25M2.5 8.75H2M5.25 2.75L5 2.25M6 8.75L3.5 12.75L7.5 11L11 12.75L10 9.75L13.5 7.75L9.5 6.75L8.5 2.75L7 6.25L3.5 5.25L6 8.75Z" })
});
export default SvgExplosionIcon;
